<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 400px; max-width: 80vw;':''">
    <q-card-section class="no-padding">
      <q-banner class="bg-primary text-white" inline-actions>
        <div>
          تعیین کرایه برای حواله
          <q-badge color="red" text="white" align="top" :label="sale_num"/>
        </div>
        <template v-slot:action>
          <q-btn flat icon="close" round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-form @submit="onSubmit" @reset="onReset">
      <q-card-section v-if="isShopOrder">
        <q-toggle v-model="driverIsOrderOwn" label="کالا توسط شخص مشتری تحویل گرفته خواهد شد"/>
      </q-card-section>
      <q-card-section>
        <q-field
            v-model="driverInfo.Transfer_Cost"
            mask="currency"
            label="کرایه حمل"
            autofocus
            filled
            dir="ltr"
            lazy-rules
            :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'کرایه حمل',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0  || 'کرایه حمل'
                    ]">
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value"
                   @change="e => emitValue(e.target.value)" v-money="moneyFormatForDirective"
                   v-show="floatingLabel">
          </template>
        </q-field>
        <q-input
            label="توضیحات"
            filled
            v-model="driverInfo.Discription"
            type="textarea"
        />
      </q-card-section>
      <q-card-actions>
        <q-btn color="indigo" text-color="white" label="تایید" icon="check" type="submit"/>
        <q-btn color="red" flat label="انصراف" icon="cancel" v-close-popup/>
      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "Driver",
  props: {
    sale_num: {
      type: Number
    },
    orderNum: {
      type: Number
    },
    isShopOrder: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      driverIsOrderOwn: false,
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      visitorsList: [],
      driverInfo: {
        Sale_Num: '',
        Visitor_ID: '',
        Transfer_Cost: '',
        Discription: ''
      }
    }
  },
  methods: {
    ...mapActions({
      readVisitors: 'Orders/readVisitors',
      changeDriver: 'Orders/changeDrive',
      setExiState: 'Orders/setExiSaleState',
      generateFactory: 'Orders/generateFactor'
    }),
    onSubmit() {
      this.driverInfo.Sale_Num = this.sale_num;
      this.driverInfo.Visitor_ID = 21
      this.driverInfo.Transfer_Cost = this.driverInfo.Transfer_Cost.toString().replaceAll(',', '')
      this.changeDriver(this.driverInfo).then(() => {
        if (this.isShopOrder) {
          this.setExiState(this.sale_num).then(() => {
            this.$q.notify({
              type: 'positive',
              color: 'positive',
              position: 'top',
              message: `تاییدیه خروج صادر شد`
            })
            if (this.driverIsOrderOwn) {
              this.generateFactory(
                  {
                    Order_Num: this.orderNum,
                    Sale_Num: this.sale_num
                  }).then((res) => {
                this.$q.notify({
                  message: `فاکتور به شماره ${res.data[0].Sale_Num} صادر شد`,
                  position: 'top',
                  color: 'negative',
                  type: 'negative'
                })
              })
            }
          })
        }
        this.$emit('close-driver-dialog')
      })
    },
    onReset() {
      this.driverInfo = {
        Sale_Num: '',
        Visitor_ID: '',
        Transfer_Cost: '',
        Discription: ''
      }
    },
    selectRule(val) {
      if (val === null || val === '') {
        return 'انتخاب نوع گزارش الزامی است'
      }
    },
  },
  created() {
    this.readVisitors(this.sale_num).then((res) => {
      this.visitorsList = eval(res.data.visitors);
      this.driverInfo.sale_num = this.sale_num;
      if (eval(res.data.saleInfo).length > 0) {
        this.driverInfo.Visitor_ID = this.visitorsList.filter(item => item.Visitor_ID === eval(res.data.saleInfo)[0].Visitor_ID)[0]
        this.driverInfo.Transfer_Cost = eval(res.data.saleInfo)[0].Transfer_Cost
        this.driverInfo.Discription = eval(res.data.saleInfo)[0].Discription
      }
    })
  }
}
</script>

<style scoped>

</style>